import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsTeaserComponent extends Component {
  // Services
  @service data;

  // Defaults
  teaserCategories = [];

  // Hooks
  constructor() {
    super(...arguments);

    this.teaserCategories = this.data.getCategories({
      'filter[type]': 'TEASER_STANDALONE_TYPE',
    });
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field
              @property='category'
              @type='select-record'
              @isSearchEnabled={{true}}
              @options={{this.teaserCategories}}
            />

            <fieldset.field @property='headline' />
            <fieldset.field @property='text' @type='text-editor' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @filters={{hash assetFolderId='10'}}
              @property='asset'
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @options={{hash allowedFolder='100'}}
              @property='backgroundImage'
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @filters={{hash assetFolderId='11'}}
              @property='youniverseStageAssets'
              @options={{hash allowedFolder='101'}}
              @type='has-many'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @filters={{hash assetFolderId='11'}}
              @property='youniverseScreenAssets'
              @options={{hash allowedFolder='101'}}
              @type='has-many'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field @property='link' @type='belongs-to' />
          </form.fieldset>

          <form.fieldset @titleKey='taxonomies' as |fieldset|>
            <fieldset.field @property='taxa' @type='has-many' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
